export default {
  namespaced: true,
  scripts: {
    title: "comandos",
    title_main: "comandos",
    action_add: 'Criar comando',
    action_update: 'Atualizar comando',
    base_commands: 'Comandos base',
    custom_commands: 'Comandos personalizados',
    fields: {
      name: {
        label: 'Nome do comando',
        placeholder: 'Nome do comando'
      },
      description: {
        label: 'Descrição do comando',
        placeholder: 'Descrição do comando'
      },
      requirements: {
        label: 'Requisitos (opcional)'
      }
    },
    messages: {
      success_created: 'Comando criado com sucesso',
      success_updated: 'Comando atualizado com sucesso',
      layout_empty: 'Não é possível salvar um comando vazio',
      connections_empty: 'Nós sem conexão não são permitidos',
      connections_qty_exceeded: 'Nós com múltiplas conexões não são permitidos',
      incomplete_node_config: 'Configuração incompleta nos seguintes nós',
    },
  },
};
